module.exports = __webpack_public_path__ + "static/media/16UNODC9.dca309c2.jpg";